const translationEN = {
    // "Diagnostic": "Diagnostic",
    // "Choisissez votre profil": "Choose your profile",
    // "Standard": "Standard",
    // "Avancé": "Advanced"
};

export default translationEN;